export default {
  // 侧边导航栏
  navigation: {
    home: 'الرئيسية',
    gameCenter: 'مركز الألعاب',
    rechargeCenter: '充值中心',
    imChat: 'محادثة IM',
    consult: 'استشارة نجمية',
  },

  // الصفحة الرئيسية
  home: {
    platformFeatures: 'مميزات المنصة',
    quickActionsName: 'إجراءات سريعة',
    footerText: 'اجعل البث أكثر بساطة والتفاعل أكثر متعة',
    features: {
      gameCenter: {
        title: 'مركز الألعاب',
        description: 'موارد ألعاب غنية تدعم البث على منصات متعددة',
      },
      imChat: {
        title: 'المراسلة الفورية',
        description: 'تفاعل محادثة في الوقت الفعلي لتعزيز تجربة المشاهد',
      },
      dataAnalysis: {
        title: 'تحليل البيانات',
        description: 'إحصائيات مفصلة لتحسين أداء البث',
      },
      efficientStable: {
        title: 'فعال ومستقر',
        description: 'تجربة بث سلسة مع خدمة موثوقة',
      },
    },
    stats: {
      activeUsers: 'المستخدمون النشطون',
      gameResources: 'موارد الألعاب',
      serviceAvailability: 'توفر الخدمة',
      technicalSupport: 'الدعم الفني',
    },
    quickActions: {
      gameCenter: 'مركز الألعاب',
      imChat: 'محادثة IM',
      consult: 'استشارة',
    },
  },

  // 游戏中心
  gameCenter: {
    language: 'العربية',
    balance: 'الرصيد',
    hotGames: 'الألعاب الأكثر مشاهدة',
    download: 'تحميل',
    update: 'تحديث',
    startTikTok: 'ابدأ البث',
    startBigo: 'ابدأ البث',
    document: 'وثيقة',
    currentGame: 'اللعبة الحالية المبثوثة:',
    currentStatus: 'الحالة الحالية للبث:',
    recharge: 'إعادة الشحن',
    restart: 'إعادة تشغيل الأداة واللعبة',
    closeLive: 'أغلق البث',
    downloadProgress: 'تقدم التحميل:',
    decompProgress: 'تقدم التفريغ:',
    waitDecomp: 'انتظر التفريغ',
    fixBug: 'إصلاح الأخطاء (Fix bug)',
    clickUpdate: 'انقر لتحديث (Click update)',
    downloading: 'جارٍ التحميل، يرجى الانتظار بصبر ~(Please wait patiently while downloading ~)',
    pay: 'جارٍ الدفع...',
    xzf: 'مطلوب الدفع',
    zs: 'الماس',
    dest: 'مشغل للبلاك لجيم',
    getff: 'فتح',
    ffbtun: 'بث مراجعة ضد الآلة',
    qrkb: 'تأكيد البث',
    tkl: 'هل أنت مستعد لبدء المراجعة والبث المضاد للآلة؟',
    qd: 'تأكيد',
    qx: 'إلغاء',
  },

  // IM聊天
  imChat: {
    search: 'بحث',
    searchNoResult: 'لم يتم العثور على المستخدم',
    tryOtherKeywords: 'يرجى محاولة استخدام كلمات دلالية أخرى',
    noConversations: 'لا توجد سجلات محادثة',
    startChatting: 'ابحث عن مستخدم للبدء في الدردشة',
    loadingConversations: 'جارٍ تحميل قائمة المحادثات...',
    connecting: 'جارٍ الاتصال بخادم الدردشة...',
    connectionFailed: '⚠️فشل الاتصال،能暂不可用',
    checkNetwork: 'يرجى التحقق من الاتصال بالشبكة أو الاتصال بالدعم الفني',
    selectUser: 'يرجى اختيار مستخدم للبدء في الدردشة',
    sending: 'جارٍ الإرسال...',
    sendMessage: 'إرسال',
    enterMessage: 'يرجى إدخال رسالة...',
    noMessages: 'لا توجد رسائل',
    welcomeChat: 'مرحبا بكم في استخدام ميزة الدردشة',
    selectConversationHint: 'يرجى اختيار محادثة من القائمة على اليسار للبدء في الدردشة',
    inputDisabledDisconnected:
      'انقطع الاتصال. الدردشة غير متاحة مؤقتًا. باقي الوظائف تعمل بشكل طبيعي. يُرجى تسجيل الدخول مرة أخرى لاستعادة وظيفة الدردشة.',
    inputDisabledOfficialNotification:
      'الإشعارات الرسمية هي إشعارات أحادية الاتجاه، يمكنك استلام الرسائل فقط',
    RecentSessions: 'الجلسات الأخيرة',
    RecommendedChat: 'الأصدقاء العالميون',
    Online: 'الآنLINE',
    Offline: 'غير متصل',
  },

  // 咨询
  StalConsult: {
    search2: 'بحث',
    all: 'الكل',
    Payment: 'الدفع',
    ViewFullContent: 'عرض المحتوى الكامل',
    UnlockFullContent: 'فتح المحتوى الكامل',
    NeedToPay: 'مطلوب الدفع',
    diamond: 'الماس',
    CurrentBalance: 'الرصيد الحالي',
    Cancel: 'إلغاء',
    PayNow: 'ادفع الآن',
    InsufficientBalance: 'رصيد غير كاف',
    loading: 'جارٍ التحميل...',
    NoMoreContent: 'لا يوجد مزيد من المحتوى',
    return: 'يعود',
    fd: 'قم بالتكبير للعرض',
  },

  // 通用提示
  common: {
    confirm: 'تأكيد',
    cancel: 'إلغاء',
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تحرير',
    loading: 'جارٍ التحميل...',
    success: 'نجاح',
    failed: 'فشل',
    error: 'خطأ',
    warning: 'تحذير',
    info: 'معلومات',
  },
}
